import React from 'react';
import { WelcomeMessageWrapper, FooterWrapper, StyledButton } from './SignupMessage.styles';

export function SignupMessage({setSignUpState}) {
  return (
    <WelcomeMessageWrapper>
      <h3>Let's get started</h3>
      <p>Create an account to access all the great features DoveMed has to offer.</p>
      <p>It takes less than <b>30 seconds</b> to do so.</p>
      <FooterWrapper>
        <p>Have an account?</p>
        <StyledButton onClick={() => setSignUpState(false)}>Login</StyledButton>
      </FooterWrapper>
    </WelcomeMessageWrapper>
  )
}
